import React from 'react';
import { useAppStore } from '../store/useAppStore';
import Icon from './Icon';

const ICON_MAP = { success: 'check', danger: 'warn', warn: 'warn', info: 'info' } as const;

export default function ToastHost() {
  const { toasts, dismissToast } = useAppStore();

  return (
    <div className="t-toast-host" aria-live="polite">
      {toasts.map(t => (
        <div key={t.id} className={['t-toast', t.tone && `t-toast--${t.tone}`].filter(Boolean).join(' ')}>
          {t.tone && <Icon name={ICON_MAP[t.tone]} size={14} />}
          <div style={{ flex: 1, minWidth: 0 }}>{t.message}</div>
          <button
            onClick={() => dismissToast(t.id)}
            aria-label="Dismiss"
            style={{ background: 'transparent', border: 'none', color: 'inherit', cursor: 'pointer', opacity: 0.7, padding: 0, display: 'grid', placeItems: 'center' }}
          >
            <Icon name="x" size={11} />
          </button>
        </div>
      ))}
    </div>
  );
}
